import React from 'react'

type PropsT = {
  className?: string
  fillColor?: string
}
const BrowseAllReports: React.FC<PropsT> = props => {
  const { className, fillColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M1.16669 1.75H12.8334M12.25 1.75V8.16667C12.25 8.47609 12.1271 8.77283 11.9083 8.99162C11.6895 9.21042 11.3928 9.33333 11.0834 9.33333H2.91669C2.60727 9.33333 2.31052 9.21042 2.09173 8.99162C1.87294 8.77283 1.75002 8.47609 1.75002 8.16667V1.75M4.08335 12.25L7.00002 9.33333L9.91669 12.25"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BrowseAllReports
